import { env, envJump } from '@/modules/globals'
import { getTerminaDomain } from '@/utils/utils'
import qs from 'qs'

/**
 * jst-light-pay 这个项目下
 * src/common/layouts/BaseLayout.tsx
 */

interface Query {
    /**
     * 跳转到【在线收付款】页面并提示：您有多个开了余额免密支付的账户，请您选择账户进行设置
     */
    closeAutoPayGuide?: 1
    /**
     * 支付单号
     */
    orderNos?: string
    autoPayGuide?: 1
    settingMechartId?: string //  点击后跳转「在线收付款」并打开「余额免密支付」设置弹窗（需校验权限、短信验证）
    openRechargeTip?: string // 点击后跳转「在线收付款」页面，并弹出扫码充值浮层
}

interface OpenProps {
    query?: Query
    isWindowOpen?: boolean
}
/**
 * 打开在线收付款页面
 * 兼容 供应侧,渠道侧,内嵌erp,独立站
 */
const openOnlinePayment = async ({ query = {}, isWindowOpen }: OpenProps = {}) => {
    const isGyl = await env.isGyl() // 是否供应链
    const search = query
        ? qs.stringify(query, {
              addQueryPrefix: true
          })
        : ''
    let OPEN_PAY_ACCOUNT_PAGE =
        (window.MASTER_IS_SUPPLIER ? '/tradeManage/onlinePayment' : '/channel/my/onlinePayment') + search

    if (isWindowOpen) {
        let terminalName = ''
        if (window.MASTER_IS_CHANNEL) {
            terminalName = window.PROJECT_CONFIG.channelTerminalName
        }
        if (window.MASTER_IS_SUPPLIER) {
            terminalName = window.PROJECT_CONFIG.supplierTerminalName
        }
        window.open(getTerminaDomain(terminalName) + OPEN_PAY_ACCOUNT_PAGE)
        return
    }
    if (isGyl) {
        if (window.MASTER_IS_DZL_CSS) {
            window.open(
                `${getTerminaDomain(window.PROJECT_CONFIG.channelTerminalName)}/channel/my/onlinePayment` + search
            )
            return
        }

        envJump.open({
            url: OPEN_PAY_ACCOUNT_PAGE,
            name: '开通云资金账号'
        })
        return
    }

    envJump.open({
        name: '分销资金管理',
        url: '/?n=分销资金管理&m=f'
    })
}

export default openOnlinePayment
